define('post-editor/mce-tools',{
	setCss: function (elem, property, value) {
		elem.css(property, value);
		// see #237, tinymce resets the style attribute to data-mce-style on save
		elem.attr('data-mce-style', elem.attr('style'));
	}
});

